// frontend/src/components/CropperModal.jsx

import React from "react";
import { createPortal } from "react-dom";
import Cropper from "react-easy-crop";
import { X } from "phosphor-react";

export default function CropperModal({
  open,

  image,
  crop = { x: 0, y: 0 },
  zoom = 1,
  aspect = 1,
  cropPixels,

  setCrop,
  setZoom,
  onCropComplete,

  onClose,
  onSkip,
  onApply,

  title = "Crop Image",
  skipLabel = "Skip",
  applyLabel = "Use cropped",

  cropShape = "rect",
  applyDisabled = false,
}) {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[100000] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/60"
        onClick={onClose}
      />

      <div className="relative z-[100001] w-full max-w-[360px] overflow-hidden rounded-2xl bg-white shadow-[0_8px_0px_rgba(37,99,235,0.96)]">
        <div className="flex items-center justify-between px-4 pt-4 pb-0">
          <h3 className="font-semibold">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="grid h-8 w-8 place-items-center text-gray-900 hover:text-gray-700"
            aria-label="Close"
          >
            <X size={18} weight="bold" />
          </button>
        </div>

        <div className="space-y-4 px-4 pb-4 pt-3">
          <div className="relative aspect-square w-full overflow-hidden rounded bg-black/5">
            <Cropper
              image={image}
              crop={crop}
              zoom={zoom}
              aspect={aspect}
              cropShape={cropShape}
              showGrid={false}
              restrictPosition
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </div>

          <div className="flex items-center gap-3">
            <label className="text-sm text-gray-600">Zoom</label>

            <input
              type="range"
              min={1}
              max={3}
              step={0.01}
              value={zoom}
              onChange={(e) => setZoom(Number(e.target.value))}
              className="w-full"
            />
          </div>

          <div className="flex justify-end gap-2">
            <button
              type="button"
              className="rounded-full border border-gray-300 !min-h-0 !min-w-0 !px-3 !h-9 text-sm"
              onClick={onSkip}
            >
              {skipLabel}
            </button>

            <button
              type="button"
              className="rounded-full bg-blue-600 !min-h-0 !min-w-0 !px-3 !h-9 text-sm text-white disabled:opacity-50"
              onClick={onApply}
              disabled={!cropPixels || applyDisabled}
            >
              {applyLabel}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}